export default __webpack_public_path__ + "static/media/loading.850698c3.gif";